export class SchemeInstallmentConfigurationModel {
  constructor(
    public key: number,
    public schemeInstKey: number,
    public installmentType: string,
    public installmentPercent: number,
    public instPaymentInterestRate: number,
    public installmentDuePaymentDays: number,
    public installmentDuePaymentDaysWithInterest: number,
    public otherCharge: string,
    public installmentAmount: number,
    public lotteryKey: number,
    public schemeKey: number,
    public intrestChartLst: string[]
  ) {}
}
